module.exports = __webpack_public_path__ + "static/img/0201_04.190a930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0201_04.jpg
// module id = agVF
// module chunks = 1